// One button. There is no password and no register: access is a Google
// Workspace account that an operator has allowlisted with
// `pnpm db:admin:create`, and nothing on this screen can change that.
import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "../../auth/AuthContext";

export function LoginPage() {
  const { startSignIn } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onClick = async (): Promise<void> => {
    setBusy(true);
    setError(null);
    const failure = await startSignIn();
    // On success the browser has already navigated to Google.
    if (failure) {
      setError(failure);
      setBusy(false);
    }
  };

  return (
    <div className="flex h-screen items-center justify-center bg-chrome-deep px-6">
      <div className="w-full max-w-[380px] rounded-xl bg-white p-8 shadow-xl">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex size-10 items-center justify-center rounded-lg bg-brand-tint text-brand">
            <ShieldCheck className="size-5" aria-hidden />
          </div>
          <div>
            <div className="font-display text-[1rem] font-bold tracking-[0.04em] text-ink uppercase">
              GroundBrain Backoffice
            </div>
            <div className="text-[0.78rem] text-muted">Support &amp; hypercare</div>
          </div>
        </div>
        <Button className="w-full" onClick={() => void onClick()} disabled={busy}>
          {busy ? "Redirecting…" : "Sign in with Google"}
        </Button>
        {error && <p className="mt-4 text-[0.8rem] text-danger">{error}</p>}
        <p className="mt-6 text-[0.72rem] leading-relaxed text-faint">
          Groundbrain employees only. Your Google Workspace account must be on
          the admin allowlist.
        </p>
      </div>
    </div>
  );
}
